/**
 * Unit tab · Guide clips. Short how-to videos (edited elsewhere, uploaded here) for the guidebook.
 */
import { MediaThumb } from "@/components/media/MediaThumb";

type Clip = { id: string; title: string; room: string | null; photo_urls: string[]; video_url: string | null };

export function UnitGuideClipsPage({ entries, onAdd }: { entries: Clip[]; onAdd: () => void }) {
  if (entries.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-[24px] bg-white px-6 py-16 text-center">
        <div className="text-[22px] font-bold tracking-[-0.3px] text-[#0f1720]">How-to videos for guests</div>
        <div className="max-w-[420px] text-[15px] font-medium text-[#64748b]">Film how to use things. We'll edit it for the guest guide.</div>
        <button type="button" onClick={onAdd} className="mt-2 flex h-12 items-center rounded-[14px] bg-[#15776d] px-6 text-[15px] font-bold text-white">
          Add clip
        </button>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-[22px] font-bold tracking-[-0.3px] text-[#0f1720]">Guide clips</div>
          <div className="text-[14px] font-medium text-[#64748b]">Short how-to videos for the guest guidebook. Edit in CapCut, upload the final clip.</div>
        </div>
        <button type="button" onClick={onAdd} className="flex h-11 shrink-0 items-center rounded-[14px] bg-[#15776d] px-4 text-[14.5px] font-bold text-white">
          Add clip
        </button>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {entries.map((g) => (
          <div key={g.id} className="overflow-hidden rounded-[22px] bg-white">
            <div className="aspect-video w-full bg-[#eef2f5]">
              {g.photo_urls?.[0] || g.video_url ? <MediaThumb url={(g.photo_urls?.[0] || g.video_url) as string} className="h-full w-full" /> : null}
            </div>
            <div className="px-4 py-3">
              <div className="truncate text-[16.5px] font-bold text-[#0f1720]">{g.title}</div>
              <div className="truncate text-[13px] font-medium text-[#8494a2]">{g.room || "Any room"}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
